import { ListingsAsyncActions } from 'store/actions/listings';
import { createReducerFromActions } from 'utils/store';
import { values } from 'lodash';

export default createReducerFromActions(...values(ListingsAsyncActions));
